// extracted by mini-css-extract-plugin
export default {"text-m":"GlowingIcon_text-m__w4U1K","text-s":"GlowingIcon_text-s__methZ","text-xs":"GlowingIcon_text-xs__iAznc","glowingIcon":"GlowingIcon_glowingIcon__preI-"};